// extracted by mini-css-extract-plugin
export default {"wrapper":"Row_wrapper__QQCT9","row":"Row_row__vfLRa","borderBottom":"Row_borderBottom__evkry","alignLeft":"Row_alignLeft__FVIWj"};